module.exports = __webpack_public_path__ + "img/m-banner-csrrksao-id-ID.e8eaf239.jpg";